declare global {
  interface Window {
    clarity?: {
      q?: any[];
      [key: string]: any;
    };
  }
}

export const initClarity = (): void => {
  (function(c: typeof window, l: Document, a: string, r: string, i: string, t?: HTMLScriptElement, y?: HTMLScriptElement) {
    (c as any)[a] = (c as any)[a] || function() {
      ((c as any)[a].q = (c as any)[a].q || []).push(arguments);
    };
    t = l.createElement(r) as HTMLScriptElement;
    if (t) {
      t.async = true;
      t.src = "https://www.clarity.ms/tag/" + i;
    }
    y = l.getElementsByTagName(r)[0] as HTMLScriptElement;
    if (y && y.parentNode && t) {
      y.parentNode.insertBefore(t, y);
    }
  })(window, document, "clarity", "script", "rtp5jlfsmk");
}; 